import type { SVGProps } from 'react';
const SvgFoodBank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#food_bank_svg__a)">
      <path
        fill="currentColor"
        d="M12 3 4 9v12h16V9l-8-6Zm.5 9.5c0 .83-.67 1.5-1.5 1.5v4h-1v-4c-.83 0-1.5-.67-1.5-1.5v-3h1v3h.5v-3h1v3h.5v-3h1v3ZM15 18h-1v-3.5h-1v-3c0-1.1.9-2 2-2V18Z"
      />
    </g>
    <defs>
      <clipPath id="food_bank_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFoodBank;
